import React from 'react';
import ReactLoading from 'react-loading';
import './index.scss';

import HatenaIcon from 'components/atoms/Icon/HatenaIcon';
import { hatenaTextList } from 'utils/constant';

const SpMarketPrice = ({ type }) => {
  const {
    oneSuggestSalary,
  } = hatenaTextList;
  const oneMarketPrice = () => (
    <div className="oneSuggestSalary">
      <div className="oneSalaryTitle">
        類似案件の金額目安
        <span className="hatenaIcon">
          <HatenaIcon
            text={oneSuggestSalary}
            place="sp"
          />
        </span>
      </div>
      <div className="oneSuggestHourSalary">
        1時間あたりの請求額：
        <span id="suggestHourSalaryMin" />
        円 ~
        {' '}
        <span id="suggestHourSalaryMax" />
        円
        
      </div>
    </div>
  );
  const loadingMarketPrice = () =>(
    <div className="loadingSuggestSalary">
      <div className="loadingSalaryTitle"> 
        類似案件の金額目安
        <span className="hatenaIcon">
          <HatenaIcon
            text={oneSuggestSalary}
            place="sp"
          />
        </span>
        <ReactLoading className="loadingIcon" type="spin" color="#03B8DF" height="14px" width="14px" />
      </div>
      <div className="loadingSuggestHourSalary">
        1時間あたりの請求額：
        -
      </div>
    </div>
  );
  return(
    <div className="SpMarketPrice">
      <div className="oneMarketPrice">{type === 'one' && oneMarketPrice() }</div>
      <div className="loadingMarketPrice">{type === 'loading' && loadingMarketPrice() }</div>
    </div>
  );
};


export default SpMarketPrice;